import { render, staticRenderFns } from "./CreateTicket.vue?vue&type=template&id=6ce2e8d9&scoped=true"
import script from "./CreateTicket.vue?vue&type=script&lang=js"
export * from "./CreateTicket.vue?vue&type=script&lang=js"
import style0 from "./CreateTicket.vue?vue&type=style&index=0&id=6ce2e8d9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ce2e8d9",
  null
  
)

export default component.exports